/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseOfString } from '../../models/api-response-of-string';

export interface UserChangePassword$Params {
  userID?: number;
  currentPassword?: string | null;
  newPassword?: string | null;
  practiceId?: string | null;
}

export function userChangePassword(http: HttpClient, rootUrl: string, params?: UserChangePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
  const rb = new RequestBuilder(rootUrl, userChangePassword.PATH, 'get');
  if (params) {
    rb.query('userID', params.userID, {});
    rb.query('currentPassword', params.currentPassword, {});
    rb.query('newPassword', params.newPassword, {});
    rb.query('practiceId', params.practiceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseOfString>;
    })
  );
}

userChangePassword.PATH = '/user/changepassword';
